import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {CreateResult, DeleteResult, ListResult, SingleResult} from './lib-rest';

export type LicenseState = 'TRIAL' | 'ACTIVE' | 'ASSOCIATION_ACTIVE' | 'CANCEL_AT_PERIOD_END' | 'SUSPENDED' | 'EXPIRED' | 'DELETED'
export class LicenseStateValues {
static readonly   ACTIVE: LicenseState = 'ACTIVE';
static readonly   ASSOCIATION_ACTIVE: LicenseState = 'ASSOCIATION_ACTIVE';
static readonly   CANCEL_AT_PERIOD_END: LicenseState = 'CANCEL_AT_PERIOD_END';
static readonly   DELETED: LicenseState = 'DELETED';
static readonly   EXPIRED: LicenseState = 'EXPIRED';
static readonly   SUSPENDED: LicenseState = 'SUSPENDED';
static readonly   TRIAL: LicenseState = 'TRIAL';
};

export class SubscriptionLogsApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async history(breederId: string): Promise<ListResult<string> >  {
const url =  new URL('/subscriptions/logs/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

export type SubscriptionType = 'TRIAL' | 'INDIVIDUAL' | 'VOLUME'
export class SubscriptionTypeValues {
static readonly   INDIVIDUAL: SubscriptionType = 'INDIVIDUAL';
static readonly   TRIAL: SubscriptionType = 'TRIAL';
static readonly   VOLUME: SubscriptionType = 'VOLUME';
};

export class SubscriptionsApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async get(): Promise<SingleResult<SubscriptionsController$SubscriptionJson> >  {
const url =  new URL('/subscriptions/active', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async listAll(): Promise<ListResult<SubscriptionsController$SubscriptionListJson> >  {
const url =  new URL('/subscriptions', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async subscribe(breederId: string, body?: SubscriptionsController$SubscribeRequestJson): Promise<CreateResult>  {
const url =  new URL('/subscriptions/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(body))).data
  }

 public  async subscribeAssociation(registryId: string, body: SubscriptionsController$SubscribeRequestJson): Promise<CreateResult>  {
const url =  new URL('/subscriptions/registry/' + registryId + '', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(body))).data
  }

 public  async unsubscribe(breederId: string): Promise<DeleteResult>  {
const url =  new URL('/subscriptions/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

 public  async unsubscribeAssociation(registryId: string): Promise<DeleteResult>  {
const url =  new URL('/subscriptions/registry/' + registryId + '', this.config.host);

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

}

export interface SubscriptionsController$SubscribeRequestJson {
  duration: number;
  start: any | null;
  type: SubscriptionType;
}

export interface SubscriptionsController$SubscriptionJson {
  cancelledAt: any;
  expiresAt: any;
  type: SubscriptionType;
  validFrom: any;
}

export interface SubscriptionsController$SubscriptionListJson {
  breederId: string;
  subscription: SubscriptionsController$SubscriptionJson;
}

export class SubscriptionsTestApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async testActive(): Promise<string>  {
const url =  new URL('/subscriptions/test/active', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async testExpired(): Promise<string>  {
const url =  new URL('/subscriptions/test/expired', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

